module.exports = __webpack_public_path__ + "img/color2.b383ea8b.jpg";